if (!customElements.get('ff-comparador-barf')) {
  class FFComparadorBarf extends HTMLElement {
    connectedCallback() {
      this.onClick = this.onClick.bind(this);
      this.onKeydown = this.onKeydown.bind(this);
      this.onLeave = this.onLeave.bind(this);
      this.onDocumentClick = this.onDocumentClick.bind(this);
      this.addEventListener('click', this.onClick);
      this.addEventListener('keydown', this.onKeydown);
      this.addEventListener('focusout', this.onLeave);
      // mouseleave no burbujea: en captura llega desde cada insignia.
      this.addEventListener('mouseleave', this.onLeave, true);
      document.addEventListener('click', this.onDocumentClick);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      this.removeEventListener('keydown', this.onKeydown);
      this.removeEventListener('focusout', this.onLeave);
      this.removeEventListener('mouseleave', this.onLeave, true);
      document.removeEventListener('click', this.onDocumentClick);
    }

    onClick(event) {
      const trigger = event.target.closest('[data-ff-badge-trigger]');
      if (trigger) {
        const badge = trigger.closest('[data-ff-badge]');
        const isOpen = badge.classList.contains('is-open');
        this.closeTips();
        badge.classList.toggle('is-open', !isOpen);
        // Al cerrar con tap el boton sigue enfocado y :focus-within la mantendria visible.
        badge.classList.toggle('is-dismissed', isOpen);
        return;
      }

      const button = event.target.closest('[data-ff-species]');
      if (button) this.selectSpecies(button);
    }

    onKeydown(event) {
      if (event.key !== 'Escape') return;
      this.querySelectorAll('[data-ff-badge]').forEach((badge) => {
        if (badge.classList.contains('is-open') || badge.matches(':hover, :focus-within')) {
          badge.classList.remove('is-open');
          badge.classList.add('is-dismissed');
        }
      });
    }

    onLeave(event) {
      const badge = event.target.closest?.('[data-ff-badge]');
      if (!badge || badge.contains(event.relatedTarget)) return;
      badge.classList.remove('is-open', 'is-dismissed');
    }

    onDocumentClick(event) {
      if (!event.target.closest('[data-ff-badge]')) this.closeTips();
    }

    closeTips() {
      this.querySelectorAll('[data-ff-badge].is-open').forEach((badge) => badge.classList.remove('is-open'));
    }

    selectSpecies(button) {
      const species = button.dataset.ffSpecies;
      this.querySelectorAll('[data-ff-species]').forEach((option) => {
        option.setAttribute('aria-pressed', option === button ? 'true' : 'false');
      });
      this.querySelectorAll('a[data-ff-cta]').forEach((link) => {
        const url = link.getAttribute(`data-url-${species}`) || link.dataset.urlPerros;
        if (url) link.setAttribute('href', url);
      });
    }
  }

  customElements.define('ff-comparador-barf', FFComparadorBarf);
}
